export function isValidProperty(config, property) {
  if (property in config) {
    return config[property] != null && config[property] !== '';
  }
  return false;
}
//# sourceMappingURL=isValidProperty.js.map